"use strict";
import Server from "helpers/server";

const URL = "/nku/submission-notification";

/* Knows how to extract the analytics values from the NKU form */
function extractAnalyticsValues() {
  const form = document.querySelector(".never-knowingly-undersold-claim-form");

  const valueIfExists = (element) =>
    element && element.value ? element.value : null;
  const valueForElementAssociatedWith = (optionElem) =>
    optionElem ? form.elements[optionElem.name].value : null;
  const isHidden = (element) => element && element.offsetParent === null;
  const parseFloatValueIfExists = (element) =>
    element.value.length > 0 ? parseFloat(element.value) : null;

  function formValueMatchesOption(optionId) {
    const elem = document.getElementById(optionId);
    const checkedItems = form.querySelectorAll(`[name="${elem.name}"]:checked`);
    let result = null;
    if (checkedItems.length > 0) {
      result = valueForElementAssociatedWith(elem) === elem.value;
    }
    return result;
  }

  const alreadyPurchased = () =>
    formValueMatchesOption("already-purchased--yes-option");

  function purchasedInJohnLewisShop() {
    let result = null;
    if (alreadyPurchased()) {
      result = !isHidden(document.getElementById("bought-in-shop-msg"));
    }
    return result;
  }

  const productCode = () =>
    valueIfExists(document.getElementById("product-details--jl-product-code"));

  function purchaseDate() {
    let result = null;
    if (purchasedInJohnLewisShop())
      result = valueIfExists(
        document.getElementById("product-details--purchase-date")
      );
    return result;
  }

  const johnLewisPrice = () =>
    parseFloatValueIfExists(
      document.getElementById("product-details--jl-price")
    );

  const competitorPrice = () =>
    parseFloatValueIfExists(document.getElementById("new-johnlewis-price"));

  function priceDiff(jlPrice, otherPrice) {
    if (
      jlPrice !== null &&
      otherPrice !== null &&
      !isNaN(jlPrice) &&
      !isNaN(otherPrice)
    ) {
      return (jlPrice - otherPrice).toFixed(2);
    } else {
      return null;
    }
  }

  return {
    priceDiff: priceDiff(johnLewisPrice(), competitorPrice()),
    postPurchase: alreadyPurchased(),
    purchaseDate: purchaseDate(),
    retailer: "John Lewis",
    productCode: productCode(),
    jlShop: purchasedInJohnLewisShop(),
    sawInShop: "wwww.johnlewis.com",
  };
}

function buildQueryString(values) {
  return Object.keys(values)
    .filter((k) => values[k] !== null && typeof values[k] !== "undefined")
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(values[k])}`)
    .join("&");
}

export function sendSplunkAnalytics() {
  const values = extractAnalyticsValues();
  const queryParams = buildQueryString(values);

  if (queryParams.length > 0) {
    Server.getHtml(`${URL}?${queryParams}`, {})
      .then((response) => {
        `${response}`;
        // Do nothing, this just sent some analytics to splunk
      })
      .catch((err) => {
        `${err}`;
        // Do nothing, doesn't affect user
      });
  }
}

export function sendSplunkAnalyticsForModelChanges(state) {
  if (state.purchasedInAJohnLewisShop) {
    sendSplunkAnalytics();
  }
}
